import { useCallback, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Link, useLocation } from "react-router-dom";

// Replace the contents of your existing NoticePopup file with this file.
// No separate stylesheet, image, Firebase change or additional package is needed.
const DISABLE_NOTICE_POPUP = false;
const POPUP_KEY = "saam_tender_notice_2026_11_02_seen";
const NOTICE_ENDS_AT = new Date("2026-11-02T15:00:00+05:30").getTime();
const LIVE_TENDERS_URL = "/tender/list?channel=NAFED";
const REGISTER_URL = "/tender?tab=register&channel=NAFED&redirect=%2Ftender%2Flist%3Fchannel%3DNAFED";
let seenWithoutStorage = false;

function hasSeenNotice() {
  try { return window.sessionStorage.getItem(POPUP_KEY) === "1"; }
  catch { return seenWithoutStorage; }
}

function rememberNotice() {
  seenWithoutStorage = true;
  try { window.sessionStorage.setItem(POPUP_KEY, "1"); }
  catch { /* Storage can be unavailable in private browsing. */ }
}

const NOTICE_CSS = `
.saam-tn-overlay{position:fixed;inset:0;z-index:10000;display:flex;align-items:center;justify-content:center;padding:24px;background:rgba(9,28,24,.66);backdrop-filter:blur(4px);font-family:inherit;box-sizing:border-box;color:#173e31;line-height:1.55}
.saam-tn-overlay *{box-sizing:border-box}
.saam-tn-dialog{display:flex;flex-direction:column;width:100%;max-width:760px;max-height:calc(100vh - 48px);max-height:calc(100dvh - 48px);overflow:hidden;border:1px solid #d7e3db;border-radius:18px;background:#fff;box-shadow:0 28px 90px #031a2355;animation:saam-tn-in .2s ease-out}
.saam-tn-top{flex:none;display:flex;align-items:center;justify-content:space-between;gap:12px;padding:12px 22px;background:#153f34;color:#fff;border-top:4px solid #c5a359}
.saam-tn-tag{display:flex;align-items:center;gap:10px;font-size:12px;font-weight:700;letter-spacing:.12em;text-transform:uppercase}
.saam-tn-tag svg{width:21px;height:21px;flex:none;color:#ddc68e}
.saam-tn-overlay .saam-tn-close{display:grid;place-items:center;flex:none;width:34px;height:34px;padding:0;border:1px solid #ffffff35;border-radius:50%;background:#ffffff0a;color:#fff;cursor:pointer;line-height:1}
.saam-tn-close svg{width:18px;height:18px}
.saam-tn-close:hover{background:#ffffff20}
.saam-tn-content{min-height:0;overflow-y:auto;overscroll-behavior:contain;padding:23px 28px 22px;scrollbar-gutter:stable}
.saam-tn-identity{text-align:center;padding:0 4px 18px;border-bottom:1px solid #e0e8e2}
.saam-tn-identity p{margin:0}
.saam-tn-nodal{font-size:10px;line-height:1.6;letter-spacing:.055em;font-weight:650;color:#5a6c63;text-transform:uppercase}
.saam-tn-nodal strong{display:block;font-size:11px;color:#365a48}
.saam-tn-pmc{font-size:16px;font-weight:750;line-height:1.45;color:#164631;margin-top:9px!important}
.saam-tn-pmc-label{margin-top:3px!important;font-size:10px;letter-spacing:.13em;color:#61736a;text-transform:uppercase}
.saam-tn-intro{padding:20px 0 16px;text-align:center}
.saam-tn-overlay .saam-tn-title{font-size:26px;font-weight:750;line-height:1.5;letter-spacing:0;color:#173e31;margin:0 0 6px}
.saam-tn-intro p{margin:0;font-size:13px;color:#52685a;line-height:1.8}
.saam-tn-scheme{display:block;margin-top:4px;font-size:11px;color:#718076}
.saam-tn-regions{list-style:none;display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px;padding:0;margin:0 0 16px}
.saam-tn-regions li{border:1px solid #d9e5dc;border-radius:9px;padding:11px 10px;background:#f4f8f4;text-align:center}
.saam-tn-regions strong{display:block;font-size:15px;line-height:1.65;color:#214e36}
.saam-tn-regions span{display:block;font-size:10px;color:#728176;margin-top:2px}
.saam-tn-dates{display:grid;grid-template-columns:1fr 1fr;gap:14px;margin:0 0 16px;border:1px solid #e5dfcf;background:#fbfaf6;border-radius:10px;padding:15px 18px}
.saam-tn-dates>div+div{border-left:1px solid #e5dfcf;padding-left:18px}
.saam-tn-dates dt{font-size:12px;color:#6b6757;margin:0 0 5px}
.saam-tn-dates dd{margin:0;line-height:1.5}
.saam-tn-dates strong{display:block;font-size:19px;color:#183e30;letter-spacing:.01em}
.saam-tn-dates span{display:block;font-size:12px;color:#555f53;margin-top:2px}
.saam-tn-requirement{margin:0 0 12px;font-size:13px;line-height:1.9;color:#3b5144}
.saam-tn-requirement strong{color:#205e3d}
.saam-tn-fees{display:flex;flex-wrap:wrap;justify-content:center;gap:7px 20px;margin:0;padding:12px 0 0;border-top:1px solid #e1e8e2;font-size:11px;color:#5b6d60}
.saam-tn-fees strong{color:#294e36;font-size:12px;white-space:nowrap}
.saam-tn-footer{flex:none;border-top:1px solid #e0e7e1;background:#f8faf7;padding:16px 28px 13px}
.saam-tn-actions{display:grid;grid-template-columns:1.2fr 1fr;gap:12px}
.saam-tn-overlay .saam-tn-button{display:flex;align-items:center;justify-content:center;gap:12px;min-height:46px;border:1px solid #1f6843;border-radius:8px;padding:11px 16px;background:#1b5b3e;color:#fff!important;font-size:14px;font-weight:700;line-height:1.4;text-decoration:none!important;text-align:center;transition:background .15s}
.saam-tn-overlay .saam-tn-button:hover{background:#12492f}
.saam-tn-overlay .saam-tn-button-secondary{background:#fff;color:#24583c!important;border-color:#bdcebf}
.saam-tn-overlay .saam-tn-button-secondary:hover{background:#edf4ed}
.saam-tn-overlay :is(button,a):focus-visible{outline:3px solid #c6a24d;outline-offset:3px}
.saam-tn-footer p{margin:10px 0 0;text-align:center;font-size:10px;line-height:1.65;color:#6e7c70}
@keyframes saam-tn-in{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}
@media(max-width:600px){.saam-tn-overlay{padding:12px}.saam-tn-dialog{max-height:calc(100vh - 24px);max-height:calc(100dvh - 24px);border-radius:13px}.saam-tn-top{padding:10px 15px}.saam-tn-content{padding:17px 18px}.saam-tn-pmc{font-size:13px}.saam-tn-nodal{font-size:9px}.saam-tn-overlay .saam-tn-title{font-size:22px}.saam-tn-intro{padding:16px 0}.saam-tn-regions{gap:6px}.saam-tn-regions li{padding:9px 5px}.saam-tn-regions strong{font-size:13px}.saam-tn-regions span{font-size:9px}.saam-tn-dates{gap:10px;padding:12px}.saam-tn-dates>div+div{padding-left:10px}.saam-tn-dates strong{font-size:16px}.saam-tn-dates dt,.saam-tn-dates span{font-size:11px}.saam-tn-footer{padding:13px 18px}.saam-tn-actions{grid-template-columns:1fr;gap:8px}.saam-tn-overlay .saam-tn-button{min-height:44px;font-size:13px}.saam-tn-fees{gap:5px 13px;justify-content:flex-start}}
@media(prefers-reduced-motion:reduce){.saam-tn-dialog{animation:none}.saam-tn-button{transition:none}}
`;

function NoticePopup() {
  const [show, setShow] = useState(false);
  const dialogRef = useRef(null);
  const closeRef = useRef(null);
  const location = useLocation();
  const isHome = location.pathname === "/";
  const closePopup = useCallback(() => {
    rememberNotice();
    setShow(false);
  }, []);

  useEffect(() => {
    if (DISABLE_NOTICE_POPUP || !isHome || Date.now() >= NOTICE_ENDS_AT) {
      setShow(false);
      return;
    }
    if (hasSeenNotice()) return;
    const timer = window.setTimeout(() => {
      if (Date.now() >= NOTICE_ENDS_AT || hasSeenNotice()) return;
      rememberNotice();
      setShow(true);
    }, 1200);
    return () => window.clearTimeout(timer);
  }, [isHome]);

  useEffect(() => {
    if (!show || !isHome) return;
    const dialog = dialogRef.current;
    const previouslyFocused = document.activeElement;
    const oldOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    closeRef.current?.focus();

    const focusables = () => Array.from(dialog.querySelectorAll('a[href],button:not([disabled]),[tabindex="0"]'));
    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        closePopup();
      } else if (event.key === "Tab") {
        const items = focusables();
        const first = items[0], last = items[items.length - 1];
        if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) {
          event.preventDefault(); last?.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) {
          event.preventDefault(); first?.focus();
        }
      }
    };
    const onFocusIn = (event) => {
      if (!dialog.contains(event.target)) closeRef.current?.focus();
    };
    document.addEventListener("keydown", onKeyDown);
    document.addEventListener("focusin", onFocusIn);
    // Stop displaying this invitation once the published opening time is reached.
    const expiryTimer = window.setTimeout(closePopup, Math.max(0, NOTICE_ENDS_AT - Date.now()));
    return () => {
      window.clearTimeout(expiryTimer);
      document.removeEventListener("keydown", onKeyDown);
      document.removeEventListener("focusin", onFocusIn);
      document.body.style.overflow = oldOverflow;
      if (previouslyFocused?.isConnected && typeof previouslyFocused.focus === "function") previouslyFocused.focus();
    };
  }, [show, isHome, closePopup]);

  if (DISABLE_NOTICE_POPUP || !show || !isHome || typeof document === "undefined") return null;

  return createPortal(
    <div className="saam-tn-overlay" onClick={(event) => { if (event.target === event.currentTarget) closePopup(); }}>
      <style>{NOTICE_CSS}</style>
      <section ref={dialogRef} className="saam-tn-dialog" role="dialog" aria-modal="true" aria-labelledby="saam-tender-notice-title" aria-describedby="saam-tender-notice-description">
        <header className="saam-tn-top">
          <div className="saam-tn-tag">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true"><path d="m3 9 9-6 9 6v12H3V9Z"/><path d="M8 21V11h8v10M8 15h8M8 18h8"/></svg>
            <span>Tender Notice</span>
          </div>
          <button ref={closeRef} type="button" className="saam-tn-close" onClick={closePopup} aria-label="Close tender notice">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>
          </button>
        </header>

        <div className="saam-tn-content">
          <div className="saam-tn-identity">
            <p className="saam-tn-nodal">National Agricultural Cooperative Marketing Federation of India Limited<strong>NAFED · Nodal Agency</strong></p>
            <p className="saam-tn-pmc">Shine Agri Allied &amp; Marketing<br />Multistate Cooperative Society Limited</p>
            <p className="saam-tn-pmc-label">Project Management Consultant · PMC</p>
          </div>

          <div className="saam-tn-intro" lang="gu">
            <h2 id="saam-tender-notice-title" className="saam-tn-title">PEB ગોડાઉન બાંધકામ માટે ટેન્ડર</h2>
            <p id="saam-tender-notice-description">PACS સહકારી મંડળીઓ માટે ગોડાઉન તથા આનુષંગિક બાંધકામનાં કામો.
              <span className="saam-tn-scheme" lang="en">Under “The World’s Largest Grain Storage Project” Scheme</span>
            </p>
          </div>

          <ul className="saam-tn-regions" aria-label="Tender areas">
            <li><strong lang="gu">અમરેલી</strong><span>Amreli</span></li>
            <li><strong lang="gu">પંચમહાલ અને મહીસાગર</strong><span>Panchmahal &amp; Mahisagar</span></li>
            <li><strong lang="gu">વાવ-થરાદ</strong><span>Vav-Tharad</span></li>
          </ul>

          <dl className="saam-tn-dates" lang="gu">
            <div><dt>ટેન્ડર ખોલવાની તારીખ</dt><dd><strong><time dateTime="2026-11-02T15:00:00+05:30">02/11/2026</time></strong><span>બપોરે 3:00 વાગ્યે · IST</span></dd></div>
            <div><dt>ઓફિસમાં દસ્તાવેજો પહોંચાડવાની મુદત</dt><dd><strong>02/11/2026</strong><span>બપોરે 3:00 વાગ્યા પહેલાં · IST</span></dd></div>
          </dl>

          <p className="saam-tn-requirement" lang="gu"><strong>અરજી કરતાં પહેલાં Vendor Registration ફરજિયાત છે.</strong> નોંધાયેલા વેન્ડરો Live Tenders પેજ પર ટેન્ડરની વિગતો જોઈ શકે છે અને Tender Copy, BOQ તથા અન્ય દસ્તાવેજો ડાઉનલોડ કરી શકે છે.</p>
          <p className="saam-tn-fees"><span>Registration <strong>₹2,950</strong></span><span>Tender Fee <strong>₹5,900</strong></span><span>EMD <strong>2.5%</strong></span><span>Fees include 18% GST</span></p>
        </div>

        <footer className="saam-tn-footer">
          <div className="saam-tn-actions">
            <Link to={LIVE_TENDERS_URL} onClick={closePopup} className="saam-tn-button">Live Tenders જુઓ <span aria-hidden="true">→</span></Link>
            <Link to={REGISTER_URL} onClick={closePopup} className="saam-tn-button saam-tn-button-secondary">Vendor Registration</Link>
          </div>
          <p lang="gu">દરેક ટેન્ડરની અંતિમ તારીખ, પાત્રતા અને શરતો માટે સંબંધિત ટેન્ડર દસ્તાવેજ જુઓ.</p>
        </footer>
      </section>
    </div>,
    document.body
  );
}

export default NoticePopup;
